/**
 * Comprehensive Phrases Data - Weather & Health
 * 天气和健康短语集合
 *
 * 包含天气描述和健康表达，约30个短语
 */

import { Phrase } from './phrases-types';

export const weatherHealthPhrases: Phrase[] = [
  // ==================== 天气表达 Weather Expressions ====================

  // 天气状态描述
  {
    id: 'weather_its_sunny',
    phrase: "It's sunny.",
    phonetic: '/ɪts ˈsʌni/',
    meaning: '天气晴朗。',
    usageScenario: '描述天气晴朗、阳光明媚的状态',
    example: "It's sunny today. Let's go outside!",
    exampleTranslation: '今天天气晴朗。让我们出去吧！',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'weather_its_rainy',
    phrase: "It's rainy.",
    phonetic: '/ɪts ˈreɪni/',
    meaning: '下雨了。',
    usageScenario: '描述下雨的天气状态',
    example: "It's rainy today. Don't forget your umbrella.",
    exampleTranslation: '今天下雨了。别忘了带伞。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'weather_its_cloudy',
    phrase: "It's cloudy.",
    phonetic: '/ɪts ˈklaʊdi/',
    meaning: '多云。',
    usageScenario: '描述天空有云、多云的天气',
    example: "It's cloudy. It might rain.",
    exampleTranslation: '多云。可能会下雨。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'weather_its_windy',
    phrase: "It's windy.",
    phonetic: '/ɪts ˈwɪndi/',
    meaning: '风很大。',
    usageScenario: '描述风力大、刮风的天气',
    example: "It's windy outside. Close the window.",
    exampleTranslation: '外面风很大。关上窗户。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'weather_its_snowy',
    phrase: "It's snowy.",
    phonetic: '/ɪts ˈsnoʊi/',
    meaning: '下雪了。',
    usageScenario: '描述下雪的天气状态',
    example: "It's snowy! Let's make a snowman!",
    exampleTranslation: '下雪了！让我们堆雪人吧！',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'medium'
  },

  // 温度描述
  {
    id: 'weather_its_hot',
    phrase: "It's hot.",
    phonetic: '/ɪts hɒt/',
    meaning: '天气很热。',
    usageScenario: '描述温度高、天气炎热',
    example: "It's hot today. I want some ice cream.",
    exampleTranslation: '今天很热。我想吃冰淇淋。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'weather_its_cold',
    phrase: "It's cold.",
    phonetic: '/ɪts koʊld/',
    meaning: '天气很冷。',
    usageScenario: '描述温度低、天气寒冷',
    example: "It's cold outside. Put on your coat.",
    exampleTranslation: '外面很冷。穿上你的外套。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'weather_its_warm',
    phrase: "It's warm.",
    phonetic: '/ɪts wɔːrm/',
    meaning: '天气温暖。',
    usageScenario: '描述温度适中、舒适温暖',
    example: "It's warm today. Nice weather!",
    exampleTranslation: '今天天气温暖。天气真好！',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'weather_its_cool',
    phrase: "It's cool.",
    phonetic: '/ɪts kuːl/',
    meaning: '天气凉爽。',
    usageScenario: '描述温度适宜、凉爽舒适',
    example: "It's cool in autumn.",
    exampleTranslation: '秋天天气凉爽。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'medium'
  },

  // 天气相关动作
  {
    id: 'weather_raining',
    phrase: 'It is raining.',
    phonetic: '/ɪt ɪz ˈreɪnɪŋ/',
    meaning: '正在下雨。',
    usageScenario: '描述当下正在下雨的状态',
    example: 'Look! It is raining outside.',
    exampleTranslation: '看！外面正在下雨。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'weather_snowing',
    phrase: 'It is snowing.',
    phonetic: '/ɪt ɪz ˈsnoʊɪŋ/',
    meaning: '正在下雪。',
    usageScenario: '描述当下正在下雪的状态',
    example: 'It is snowing heavily.',
    exampleTranslation: '雪下得很大。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'weather_what_weather',
    phrase: 'What is the weather like?',
    phonetic: '/wɒt ɪz ðə ˈweðər laɪk/',
    meaning: '天气怎么样？',
    usageScenario: '询问天气情况',
    example: 'What is the weather like today?',
    exampleTranslation: '今天天气怎么样？',
    category: 'asking',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'weather_good_weather',
    phrase: 'good weather',
    phonetic: '/ɡʊd ˈweðər/',
    meaning: '好天气',
    usageScenario: '描述天气状况好',
    example: 'We have good weather today!',
    exampleTranslation: '今天天气真好！',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'weather_bad_weather',
    phrase: 'bad weather',
    phonetic: '/bæd ˈweðər/',
    meaning: '坏天气',
    usageScenario: '描述天气状况不好',
    example: "It's bad weather today. Stay home.",
    exampleTranslation: '今天天气不好。待在家里吧。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'medium'
  },

  // ==================== 健康表达 Health Expressions ====================

  // 身体不适
  {
    id: 'health_have_headache',
    phrase: 'have a headache',
    phonetic: '/hæv ə ˈhedeɪk/',
    meaning: '头痛',
    usageScenario: '描述头痛的不适症状',
    example: 'I have a headache today.',
    exampleTranslation: '我今天头痛。',
    category: 'feelings',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'health_have_fever',
    phrase: 'have a fever',
    phonetic: '/hæv ə ˈfiːvər/',
    meaning: '发烧',
    usageScenario: '描述发烧的症状',
    example: 'He has a fever. He needs rest.',
    exampleTranslation: '他发烧了。他需要休息。',
    category: 'feelings',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'health_have_cold',
    phrase: 'have a cold',
    phonetic: '/hæv ə koʊld/',
    meaning: '感冒',
    usageScenario: '描述感冒的症状',
    example: 'I have a cold. I cannot go to school.',
    exampleTranslation: '我感冒了。我不能去学校。',
    category: 'feelings',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'health_have_stomachache',
    phrase: 'have a stomachache',
    phonetic: '/hæv ə ˈstʌməkeɪk/',
    meaning: '肚子疼',
    usageScenario: '描述肚子疼或胃痛的症状',
    example: 'She has a stomachache.',
    exampleTranslation: '她肚子疼。',
    category: 'feelings',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'health_have_toothache',
    phrase: 'have a toothache',
    phonetic: '/hæv ə ˈtuːθeɪk/',
    meaning: '牙疼',
    usageScenario: '描述牙齿疼痛的症状',
    example: 'I have a toothache. I need to see a dentist.',
    exampleTranslation: '我牙疼。我需要看牙医。',
    category: 'feelings',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    frequency: 'low'
  },

  // 健康状态
  {
    id: 'health_feel_sick',
    phrase: 'feel sick',
    phonetic: '/fiːl sɪk/',
    meaning: '感觉不舒服',
    usageScenario: '描述身体不适的感觉',
    example: 'I feel sick today.',
    exampleTranslation: '我今天感觉不舒服。',
    category: 'feelings',
    difficulty: 'medium',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'health_feel_well',
    phrase: 'feel well',
    phonetic: '/fiːl wel/',
    meaning: '感觉很好',
    usageScenario: '描述身体健康、状态良好',
    example: 'I feel well now.',
    exampleTranslation: '我现在感觉很好。',
    category: 'feelings',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'health_get_sick',
    phrase: 'get sick',
    phonetic: '/ɡet sɪk/',
    meaning: '生病',
    usageScenario: '描述患病的动作或过程',
    example: "Don't get sick. Take care!",
    exampleTranslation: '别生病。注意身体！',
    category: 'actions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'health_stay_healthy',
    phrase: 'stay healthy',
    phonetic: '/steɪ ˈhelθi/',
    meaning: '保持健康',
    usageScenario: '描述维持健康状态',
    example: 'Exercise helps you stay healthy.',
    exampleTranslation: '运动有助于保持健康。',
    category: 'actions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },

  // 医疗相关
  {
    id: 'health_see_doctor',
    phrase: 'see a doctor',
    phonetic: '/siː ə ˈdɒktər/',
    meaning: '看医生',
    usageScenario: '描述去看医生的行为',
    example: 'You should see a doctor.',
    exampleTranslation: '你应该去看医生。',
    category: 'actions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'health_take_medicine',
    phrase: 'take medicine',
    phonetic: '/teɪk ˈmedɪsn/',
    meaning: '吃药',
    usageScenario: '描述服用药物的行为',
    example: 'Take medicine and rest.',
    exampleTranslation: '吃药并休息。',
    category: 'actions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'health_go_to_hospital',
    phrase: 'go to hospital',
    phonetic: '/ɡoʊ tuː ˈhɒspɪtl/',
    meaning: '去医院',
    usageScenario: '描述去医院就诊的行为',
    example: "I'm sick. I need to go to hospital.",
    exampleTranslation: '我生病了。我需要去医院。',
    category: 'actions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },

  // 身体护理
  {
    id: 'health_take_care',
    phrase: 'take care!',
    phonetic: '/teɪk keər/',
    meaning: '保重！',
    usageScenario: '告别时关心对方健康',
    example: 'Goodbye! Take care!',
    exampleTranslation: '再见！保重！',
    category: 'politeness',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'health_take_care_of',
    phrase: 'take care of',
    phonetic: '/teɪk keər əv/',
    meaning: '照顾',
    usageScenario: '描述照顾某人或某物',
    example: 'I take care of my dog.',
    exampleTranslation: '我照顾我的狗。',
    category: 'actions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'health_rest',
    phrase: 'have a rest',
    phonetic: '/hæv ə rest/',
    meaning: '休息一下',
    usageScenario: '描述休息的行为',
    example: 'You are tired. Have a rest.',
    exampleTranslation: '你累了。休息一下。',
    category: 'actions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'health_exercise',
    phrase: 'do exercise',
    phonetic: '/duː ˈeksərsaɪz/',
    meaning: '做运动',
    usageScenario: '描述体育锻炼的行为',
    example: 'I do exercise every day.',
    exampleTranslation: '我每天都做运动。',
    category: 'actions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'health_drink_water',
    phrase: 'drink water',
    phonetic: '/drɪŋk ˈwɔːtər/',
    meaning: '喝水',
    usageScenario: '描述喝水的行为，保持健康',
    example: 'Drink more water. It is good for you.',
    exampleTranslation: '多喝水。对你有好处。',
    category: 'actions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
];